import React from 'react';
import { BQLink } from '../../../atoms/bqlink';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { STRINGS } from '../../../../constants';
import { getUserStatus } from '../../../../helpers/utils';
import { downloadAppDl } from '../../../../helpers/datalayer-utils';
import SocialShare from './social-share';

import './global-header.m.css';
import { mdiGooglePlay, mdiApple } from '@mdi/js';
import Icon from '@mdi/react';

export const STORE_LINKS = [
  {
    href: 'https://play.google.com/store/apps/details?id=com.ndtv.ndtvprofit&pcampaignid=web_share',
    path: mdiGooglePlay,
    title: 'Get it on',
    name: 'Google Play',
    size: '22px',
    color: '#000000',
  },
  {
    href: 'https://apps.apple.com/in/app/ndtv-profit/id502359431',
    path: mdiApple,
    title: 'Download on the',
    name: 'App Store',
    size: '22px',
    color: '#000000',
  },
];

const GlobalHeader = ({ data, setIsGlobalMenu }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType'], ''));
  const formattedPageType =
    pageType === 'story-page' ? 'story' : pageType !== 'home-page' ? 'section-page' : pageType;

  const handleClick = (item) => {
    const baseData = {
      event: 'global_interaction',
      cta_text: item?.Title?.trim()?.replace(/\s+/g, '_') || 'NA',
      page_template: formattedPageType || 'NA',
      user_id: userData?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
      language_hit: 'english',
      Platform: 'desktop',
      SiteName: 'www.ndtvprofit.com',
    };

    if (typeof window !== 'undefined' && window.localStorage) {
      window.dataLayer.push(baseData);
    } else {
      console.error('Error: window.dataLayer is not available');
    }
  };

  return (
    <div
      styleName="globalNavModal"
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={() => setIsGlobalMenu(true)}
      onMouseLeave={() => setIsGlobalMenu(false)}
    >
      <div styleName="globalNavList">
        <div styleName="heading">{STRINGS.OUR_NETWORK}</div>
        <ul styleName="globalNavItems">
          {data.map((item, idx) => (
            <li key={idx} styleName="hiddenLinkItem" onClick={handleClick(item)}>
              <span
                styleName="circleBullet"
                style={{
                  backgroundColor: item.EmbedCode || 'grey',
                }}
              />
              <BQLink
                key={item?.Title}
                href={`${item?.Link}?utm_source=profit&utm_medium=referral&utm_campaign=globnav`}
                styleName="navItem"
                target="_blank"
              >
                {item?.Title}
              </BQLink>
            </li>
          ))}
        </ul>
      </div>
      <div styleName="globalSocialList">
        <div styleName="storeSection">
          <div styleName="heading">{STRINGS.GET_APP_TEXT}</div>
          <div styleName="storeLinks">
            {STORE_LINKS?.map((store) => (
              <div
                onClick={() =>
                  downloadAppDl(store?.name, userData, formattedPageType, 'global nav')
                }
              >
                <BQLink
                  key={store?.href}
                  href={store?.href}
                  styleName="socialBtn"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <Icon path={store?.path} size={store?.size} color={store?.color} />
                  <div styleName="txtSection">
                    <div styleName="title">{store?.title}</div>
                    <div styleName="name">{store?.name}</div>
                  </div>
                </BQLink>
              </div>
            ))}
          </div>
        </div>
        <div styleName="socialSection">
          <div styleName="heading">{STRINGS.FOLLOW_NDTV_PROFIT}</div>
          <SocialShare sectionName="globnav" />
        </div>
      </div>
    </div>
  );
};

export default GlobalHeader;
